import { render, staticRenderFns } from "./EmbedModal.vue?vue&type=template&id=58c40dac&scoped=true&"
import script from "./EmbedModal.vue?vue&type=script&lang=js&"
export * from "./EmbedModal.vue?vue&type=script&lang=js&"
import style0 from "./EmbedModal.vue?vue&type=style&index=0&id=58c40dac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c40dac",
  null
  
)

export default component.exports